import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.UsersPage.AddUsersPopupContent', {
    title: 'Add or Invite Users',
    popupButtonTitleNext: 'Next',
    popupButtonTitleFinish: 'Finish',
    popupButtonTitleGoBack: 'Go back',
    inputPlaceholder: 'Enter or copy email(s) here...',
    commentTitle: 'Message to user',
    commentPlaceholder: 'Enter your message here (optional)...',
    popupButtonTextNext: 'Next',
    addUsersDescription: `Please enter emails of the users you'd like to add.
    You can add multiple emails separated by comma, semicolon or whitespace.`,
    addButtonText: 'Add',
    invalidEmailsDescription: 'The following emails are invalid and can not be added:',
    popupButtonTextGoBack: 'Go back',
    popupButtonTextFinish: 'Finish',
    inviteUsersDescription: 'Would you like to invite the users by email right away?',
    doNotInviteRadioButtonText: 'Do not invite',
    doInviteRadioButtonText: 'Invite the users by email right away',
    invalidEmailsText: '...and {count} more.',
});
